import React, { useEffect, useState } from "react";
import { SITE_TITLE } from '../../utils/constants';
import { seo } from '../../utils/seo';
import { getAuthUser } from '../../utils/user';
import POGenerator from "./tabs/po-generator";
import POHistory from "./tabs/po-history";
import SavedPO from "./tabs/saved-po";
// import UserServices from "../../services/UserServices";
import './purchase-order.css';
import '../../components/Modals/Modal.css';
import './print.css';

const PurchaseOrders = () => {
    const [activeTab, setActiveTab] = useState('po-generator');
    const [showSpinner, setShowSpinner] = useState(0);
    const [showLoader, setShowLoader] = useState(1);
    const [user, setUser] = useState({});

    useEffect(() => {
        const userObj = getAuthUser();
        setUser(userObj);
        seo({
            title: SITE_TITLE + ' || Purchase Orders',
            metaDescription: '',
        });
    }, []);

    return (
        <main className="techtop-middle-div">
            <section className="techtop-purchase-section pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="default-title">
                                <div className="row align-items-center">
                                    <div className="col-md-6">
                                        <h1 className="m-0 po-main-title">Purchase Orders</h1>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <h1 className="m-0 po-sub-title">{user?.company || user?.name || 'Techtop Customer Service'}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12" id="techtop-news-tabs">
                            <div className="common-width-div">
                                <div className="row">
                                    <div className="col-md-12">
                                        <ul className="nav nav-tabs po-tabs-bar">
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 'po-generator' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('po-generator')}
                                                >
                                                    PO Generator
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 'po-history' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('po-history')}
                                                >
                                                    PO History
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 'saved-po' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('saved-po')}
                                                >
                                                    Saved PO's
                                                </button>
                                            </li>
                                        </ul>

                                    </div>
                                </div>

                                {/* Tabs */}
                                <div className="tab-content mt-3">
                                    <POGenerator key="po-generator" active={activeTab === 'po-generator'} user={user} />
                                    <POHistory key="po-history" active={activeTab === 'po-history'} user={user} />
                                    <SavedPO key="saved-po" active={activeTab === 'saved-po'} user={user} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );

}

export default PurchaseOrders;